export const IMAGES = [
  { src: "https://i.ibb.co/9wW3b0C/image.jpg", thumbnail: "https://i.ibb.co/9wW3b0C/image.jpg" },
{ src: "https://i.ibb.co/7QT51s4/1.jpg", thumbnail: "https://i.ibb.co/7QT51s4/1.jpg" },
{ src: "https://i.ibb.co/z7rMFS1/2.jpg", thumbnail: "https://i.ibb.co/z7rMFS1/2.jpg" },
{ src: "https://i.ibb.co/wpYq1jK/3.jpg", thumbnail: "https://i.ibb.co/wpYq1jK/3.jpg" },
{ src: "https://i.ibb.co/pXNgyQG/4.jpg", thumbnail: "https://i.ibb.co/pXNgyQG/4.jpg" },
];
